export const JobStatus = {
  REGISTRATION: "REGISTRATION",
  ON_HOLD: "ON_HOLD",
  INSPECTION: "INSPECTION",
  APPROVED: "APPROVED",
  IN_PROGRESS: "IN_PROGRESS",
  TEST_DRIVE: "TEST_DRIVE",
};

export const PrivateJobStatus = {
  REJECTED: "REJECTED",
  COMPLETED: "COMPLETED",
  WAITING_FOR_APPROVAL: "WAITING_FOR_APPROVAL",
};
